export default Object.freeze({
  'Listado Firmantes Encargados': [
    'Firmante Encargado Nombre',
    'Firmante Encargado Tipo de Relación',
    'Firmante Encargado UserId',
    'Firmante Encargado Teléfono',
    'Firmante Encargado Email',
  ],
  'Listado Firmantes Proveedores': [
    'Firmante Proveedor Nombre',
    'Firmante Proveedor UserId',
    'Firmante Proveedor Teléfono',
    'Firmante Proveedor Email',
  ],
  'Listado Especialistas': [
    'Especialista Nombre',
    'Especialista Especialidad',
    'Especialista Numero de Licencia',
  ],
  'Listado Supervisores': [
    'Supervisor Nombre',
    'Supervisor Especialidad',
    'Supervisor Numero de Licencia',
  ],
});
